import { ClientError } from 'graphql-request';

/**
 * Extracts a canonical error code from an unknown thrown value.
 *
 * Resolution order:
 * 1. ClientError with extensions.code → use the code (set explicitly by the backend for actionable errors)
 * 2. ClientError without extensions.code → 'UNKNOWN' (generic server error, no actionable distinction)
 * 3. TypeError (fetch failed before server responded) → 'NETWORK_ERROR'
 * 4. Anything else → 'UNKNOWN'
 *
 * HTTP status codes are not consulted. Auth failures are handled at the middleware layer
 * before reaching GraphQL, and Apollo always responds HTTP 200 for GraphQL operations.
 */
export function extractGqlErrorCode(error: unknown): string {
  if (error instanceof ClientError) {
    const code = error.response.errors?.[0]?.extensions?.code;
    if (typeof code === 'string' && code.length > 0) {
      return code;
    }
    return 'UNKNOWN';
  }
  if (error instanceof TypeError) {
    return 'NETWORK_ERROR';
  }
  return 'UNKNOWN';
}
